export default __webpack_public_path__ + "static/media/logo.HV.d9e4790e.svg";